module.exports = __webpack_public_path__ + "img/taubman-museum-of-art.4eb79d49.jpeg";